import React from 'react';
import { motion } from 'framer-motion';
interface NeonButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  href?: string;
  className?: string;
}
export const NeonButton: React.FC<NeonButtonProps> = ({
  children,
  href,
  className = '',
  ...props
}) => {
  const baseClasses = `
    relative inline-flex items-center justify-center px-8 py-4 
    font-display font-bold text-white bg-neon-blue 
    rounded-full overflow-hidden transition-all duration-300
    hover:bg-[#00b8e6] box-glow hover:box-glow-strong
    ${className}
  `;
  const content = <>
      <span className="relative z-10" data-id="element-116">{children}</span>
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full hover:animate-[shimmer_1.5s_infinite]" data-id="element-117" />
    </>;
  if (href) {
    return <motion.a href={href} target="_blank" rel="noopener noreferrer" className={baseClasses} whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} data-id="element-118">
        {content}
      </motion.a>;
  }
  return <motion.button className={baseClasses} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} {...props} data-id="element-119">
      {content}
    </motion.button>;
};